import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import { appApi } from '~/redux/api/appApiSlice';
import {
  ValuationTypeResponseType,
  ValuationStatsTypeResponseType,
} from '~/types/valuationTypes';

export const valuationApiSlice = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getValuationList: builder.query<
      ValuationTypeResponseType,
      { type: ValuationTypeEnum; page?: number; limit?: number; locale: string }
    >({
      query: ({ type, locale, page, limit }) => {
        return {
          url: '/api/v4/valuation',
          params: { type, page: page || 1, limit: limit || 10, locale },
          headers: {
            'Accept-Language': locale,
          },
        };
      },
    }),
    getValuationStats: builder.query<
      ValuationStatsTypeResponseType,
      { type: ValuationTypeEnum }
    >({
      query: ({ type }) => {
        return {
          url: '/api/v4/valuation/stats',
          params: { type },
        };
      },
      providesTags: ['valuationStats'],
    }),
    getValuationFormSchema: builder.mutation({
      query: (valuationType) => ({
        url: `/api/v4/valuation/${valuationType}/form-schema`,
      }),
    }),
    addPropertyValuation: builder.mutation({
      query: (body) => ({
        url: '/api/v4/valuation',
        method: 'POST',
        body,
      }),
    }),
    getValuationDetails: builder.query({
      query: (valuationId) => ({
        url: `/api/v4/valuation/${valuationId}`,
      }),
    }),
  }),
});

export const {
  useLazyGetValuationListQuery,
  useGetValuationFormSchemaMutation,
  useAddPropertyValuationMutation,
  useGetValuationDetailsQuery,
  useGetValuationListQuery,
  useLazyGetValuationStatsQuery,
  useGetValuationStatsQuery,
} = valuationApiSlice;
